import { ServiceClient } from '@johnlewispartnership/wtr-website-api-client';

import config from 'config';
import { withApiBaseUrl } from 'services/with-api-base-url';
import { logger } from 'logger';

import type { CompetitionsPostRequestValues, CompetitionsPostResponse } from './types';

const BASE_URL = withApiBaseUrl(config.services.competitions.path);

class CompetitionsService extends ServiceClient {
  async submitCompetitionData(
    competitionId: string,
    competitionType: string,
    competitionEntryValues: CompetitionsPostRequestValues,
  ) {
    const competitionUrl = `competitions/${competitionId}/competitiontypes/${competitionType}/entries`;

    const response = await this.httpClient.post<
      CompetitionsPostRequestValues,
      CompetitionsPostResponse
    >(competitionUrl, competitionEntryValues, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer unauthenticated`,
        breadcrumb: config.applicationName,
      },
    });

    const correlationId = response.headers?.['wtr-correlation-id'];
    if (response.error) {
      const errorMessage = `Competition submission failed: ${response.error.message}`;
      const errorData = {
        correlationId,
        httpStatus: String(response.status),
        duration: response.duration,
        message: errorMessage,
        service: 'competitions',
        url: `${BASE_URL}${competitionUrl}`,
      };

      const error = Object.assign(new Error(errorMessage), errorData);
      logger.error(error);

      return Promise.reject(response);
    }

    logger.info({
      payload: {
        correlationId,
        httpStatus: String(response.status),
        duration: response.duration,
        message: 'Competition entry submission successful',
        service: 'competitions',
        url: `${BASE_URL}${competitionUrl}`,
      },
    });

    return response.data;
  }
}

export default new CompetitionsService(BASE_URL);
